import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from 'react-query';
import { TrackingProvider } from 'modules/analytics';
import { initIntl, LocalizationProvider } from 'modules/i18n';
import { ThemeProvider } from 'modules/minimal-ui-theme';
import { ModalProvider } from 'modules/modal';
import { initDatadog } from 'utils/datadog';
import { listenForChunkPreloadErrors } from 'utils/lazyWithReload';
import {
  listenToSWControllerChange,
  listenToSWMessages
} from 'utils/service-worker';
import { App } from './App';

void initIntl();
initDatadog();
listenForChunkPreloadErrors();
listenToSWMessages();

const queryClient = new QueryClient();

listenToSWControllerChange(queryClient);

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <LocalizationProvider>
      <QueryClientProvider client={queryClient}>
        <ThemeProvider>
          <TrackingProvider>
            <ModalProvider>
              <App />
            </ModalProvider>
          </TrackingProvider>
        </ThemeProvider>
      </QueryClientProvider>
    </LocalizationProvider>
  </React.StrictMode>
);
